import { TranslatableText, Translate } from '@dreryk/react-common';
import { StyledFlex, TestId, TextView } from '@dreryk/react-components';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

type MagistralDrugTemplateReadOnlyTextViewProps = {
   readonly children: string | undefined;
   readonly onInsertClick?: VoidFunction;
   readonly testId: TestId;
   readonly label: TranslatableText;
};

export const MagistralDrugTemplateReadOnlyTextView = (
   props: MagistralDrugTemplateReadOnlyTextViewProps
): JSX.Element => {
   return (
      <TextView
         testId={props.testId}
         label={
            <StyledFlex justifyContent={props.onInsertClick ? 'space-between' : undefined}>
               <Translate>{props.label}</Translate>
               {props.onInsertClick ? (
                  <FormsTemplates.ReadOnlyInsertLink testId={props.testId} onClick={props.onInsertClick} />
               ) : null}
            </StyledFlex>
         }
      >
         <>{props.children ?? <FormsTemplates.ReadOnlyNoInformation />}</>
      </TextView>
   );
};
